// components/Header.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <header className="fixed w-full bg-gray-300 shadow z-50">
      <nav className="container mx-auto flex items-center justify-between py-4 px-6">
        <div className="flex items-center">
          <img src="/images/HouvalLogo.png" alt="Propertise AI Group" className="h-16 w-auto" />
        </div>
        
        <button
          onClick={handleLoginClick}
          className="bg-yellow-500 text-black px-6 py-1 rounded-full text-lg hover:bg-yellow-600 transition duration-300"
        >
          Sign up / Login
        </button>
      </nav>
    </header>
  );
};

export default Header;
